import {
    Building2,
    Car,
    Factory,
    Heart,
    Info,
    Leaf,
    Lightbulb,
    Package,
    Recycle,
    ScrollText,
    type LucideIcon,
} from "lucide-react";
import { TopicItem } from "@/types";

export type TopicVisual = {
    icon: LucideIcon;
    iconBg: string;
    iconColor: string;
};

export const TOPIC_ITEMS: TopicItem[] = [
    { id: "1", text: "GREEN LIVING", key: "green_living" },
    { id: "2", text: "SUSTAINABLE PACKAGING", key: "sustainable_packaging" },
    { id: "3", text: "FUTURE MOBILITY", key: "future_mobility" },
    { id: "4", text: "BETTER CONSTRUCTION AND INFRASTRUCTURE", key: "better_construction_and_infrastructure" },
    { id: "5", text: "RESOURCE EFFICIENCY FACTORY", key: "resource_efficiency_factory" },
    { id: "6", text: "HEALTH & WELL-BEING", key: "health_well_being" },
    { id: "7", text: "CLOSING THE LOOP", key: "closing_the_loop" },
    { id: "8", text: "NEED ZONE", key: "need_zone" },
    { id: "9", text: "POLICY", key: "policy" },
    { id: "10", text: "SCGC INFORMATION", key: "scgc_info" },
];

const TOPIC_VISUALS: Record<string, TopicVisual> = {
    green_living: { icon: Leaf, iconBg: "#E8F8EE", iconColor: "#22C55E" },
    sustainable_packaging: { icon: Package, iconBg: "#E6F7F4", iconColor: "#14B8A6" },
    future_mobility: { icon: Car, iconBg: "#F0EBFF", iconColor: "#8B5CF6" },
    better_construction_and_infrastructure: { icon: Building2, iconBg: "#FFF3E8", iconColor: "#F97316" },
    resource_efficiency_factory: { icon: Factory, iconBg: "#FFF8E6", iconColor: "#D97706" },
    health_well_being: { icon: Heart, iconBg: "#FEECEC", iconColor: "#EF4444" },
    closing_the_loop: { icon: Recycle, iconBg: "#EBF4FF", iconColor: "#3B82F6" },
    need_zone: { icon: Lightbulb, iconBg: "#FFFBE6", iconColor: "#EAB308" },
    policy: { icon: ScrollText, iconBg: "#F1F5F9", iconColor: "#64748B" },
    scgc_info: { icon: Info, iconBg: "#EBF2FF", iconColor: "#2563EB" },
};

const DEFAULT_TOPIC_VISUAL: TopicVisual = {
    icon: Lightbulb,
    iconBg: "#EDF3FF",
    iconColor: "#5B6EF9",
};

export function getTopicByKey(key: string | null | undefined, topicList: TopicItem[] = TOPIC_ITEMS): TopicItem | undefined {
    if (!key) return undefined;
    return topicList.find((item) => item.key === key);
}

export function getTopicLabel(key: string | null | undefined, topicList: TopicItem[] = TOPIC_ITEMS): string {
    return getTopicByKey(key, topicList)?.text ?? "Topic";
}

export function getTopicVisual(key: string | null | undefined): TopicVisual {
    if (!key) return DEFAULT_TOPIC_VISUAL;
    return TOPIC_VISUALS[key] ?? DEFAULT_TOPIC_VISUAL;
}
